/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteSettingsUnitCommand } from '../../models/delete-settings-unit-command';
import { DeleteSettingsUnitCommandResult } from '../../models/delete-settings-unit-command-result';

export interface ApiSettingsUnitsDeleteSettingsUnitDelete$Params {
      body?: DeleteSettingsUnitCommand
}

export function apiSettingsUnitsDeleteSettingsUnitDelete(http: HttpClient, rootUrl: string, params?: ApiSettingsUnitsDeleteSettingsUnitDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteSettingsUnitCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiSettingsUnitsDeleteSettingsUnitDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteSettingsUnitCommandResult>;
    })
  );
}

apiSettingsUnitsDeleteSettingsUnitDelete.PATH = '/api/SettingsUnits/DeleteSettingsUnit';
